import styled from '@emotion/styled'
import React from 'react'
import { getContrastSafeColor } from './utils'
import { colors } from '../../../tokens/colors'

type Props = {
  children: React.ReactNode
  backgroundColor?: string
  ref?: React.Ref<HTMLDivElement>
}

export const FullWidth = ({ children, backgroundColor }: Props) => {
  let color
  if (backgroundColor) {
    color = getContrastSafeColor(backgroundColor)
  }

  return (
    <Container backgroundColor={backgroundColor} color={color}>
      {children}
    </Container>
  )
}

const Container = styled('div')<{
  backgroundColor?: string
  color?: string
}>`
  padding: 48px 24px;
  color: ${({ color }) => color || colors.copy.paragraphDark};
  background-color: ${({ backgroundColor }) =>
    backgroundColor || colors.background.secondaryBackground};

  @media print {
    padding: 48px 36px;
  }
`
